import Modal from 'libs/components/modal';

const initalizePaymentService = element => {
  const $addCouponBtn = $('#js-add_coupon_code');
  const $couponCodeForm = $('#js-coupon_code_form');

  if ($couponCodeForm) $couponCodeForm.hide();

  if ($addCouponBtn) {
    $addCouponBtn.click(() => {
      $addCouponBtn.hide();

      $couponCodeForm.show();

      $('input#coupon-code-txt').focus();

      $('input#coupon-code-txt')
        .off('keyup.coupon_code')
        .on('keyup.coupon_code', event => {
          if (event.which == 27) {
            $addCouponBtn.show();
            $couponCodeForm.hide();
          }
        });

      $('#js-coupon-apply-link').click(() => $('#redeem-code-form').submit());
    });

    $('#js-coupon-apply-link').click(() => $('#redeem-code-form').submit());
  }

  const $addonBtns = $('[data-addon]');

  $addonBtns.on('click', evt => {
    evt.preventDefault();

    const addon = JSON.parse(evt.target.dataset.addon)

    new Kadenze.AjaxRequest({
      url: Kadenze.Routes.shop_add_addon_to_cart_path(
        addon.addon_type,
        addon.product_id,
      ),
      type: 'POST',
    }).done(xhr => window.location.href = xhr.next_url);
  });

  const $removeLinks = $('.js-remove-item');

  $removeLinks.on('click', e => {
    e.stopImmediatePropagation();
    e.preventDefault();

    const href = e.target.href;

    if ($removeLinks.length == 1) {
      const $modal = Modal.for('confirmation-w-icon', {
        title: I18n.t('cart.leave_checkout_modal.title'),
        body: I18n.t('cart.leave_checkout_modal.body'),
        okBtnText: I18n.t('cart.leave_checkout_modal.ok_btn_text'),
        cancelBtnText: I18n.t('cart.leave_checkout_modal.cancel_btn_text'),
        layoutType: 'icon',
        iconClass: 'kf-cart'
      });

      $modal.find('.js_cancel').on('click', () => $modal.modal('hide'));

      $modal.find('.js_ok').on('click', () => {
        new Kadenze.AjaxRequest({
          url: href,
          type: 'POST'
        }).done(xhr => window.location.href = xhr.next_url);
      });
    } else {
      new Kadenze.AjaxRequest({
        url: href,
        type: 'POST'
      }).done(() => document.location.reload(true));
    }
  });

  const paymentHandler = StripeCheckout.configure({
    key: element.dataset.key,
    image: element.dataset.logoPath,
    token: token => {
      Kadenze.UIUtil.showLoadingIndicator(null, null, 'fixed');

      //
      // cartItems is a const set up in the Haml view
      //
      if (ga && (typeof cartItems !== 'undefined')) {
        for (let i=0; i<cartItems.length; i++) {
          const item = cartItems[i];

          if (item.type == 'Shop::Plan') {
            ga('send', { hitType: 'event', eventCategory: 'subscription',
              eventAction: 'create', eventLabel: item.name
            });
          } else if (item.type == 'Shop::Course') {
            ga('send', { hitType: 'event', eventCategory: 'credit_eligible',
              eventAction: 'purchase', eventLabel: item.name
            });
          }
        }
      }

      const payload = { token };

      if (element.dataset.cartId)
        payload.id = element.dataset.cartId;

      const posting = $.post(element.dataset.postToPath, payload);

      posting.done(() => {
        Kadenze.UIUtil.hideLoadingIndicator();
        window.location.replace(element.dataset.redirectToPath);
      });

      posting.error(response => {
        Kadenze.UIUtil.hideLoadingIndicator();
        const errorMessage = response.responseText;

        Modal.for('message', {
          title: element.dataset.modalErrorTitle || "Uh Oh!",
          body: errorMessage,
          okBtnText: element.dataset.modalOkBtnText || "Continue",
        });
      });
    }
  });

  $(`#${element.dataset.buttonId}`).on('click', e => {
    //
    // Open Checkout with further options
    //
    paymentHandler.open({
      name: `${element.dataset.tenant} Checkout`,
      description: element.dataset.description,
      amount: parseInt(element.dataset.amount),
      email: element.dataset.email,
      allowRememberMe: false,
      panelLabel: element.dataset.panelLabel || "Pay {{amount}} USD",
      zipCode: true,
      billingAddress: true,
    });

    e.preventDefault();
  });

  $(window).on('popstate', () => paymentHandler.close());
};

const initializeCouponFormSubmit = () => {
  $('#js-coupon-form-submit').click(e => $(e.currentTarget).parents('form').submit());
};

export default {
  init: element => {
    initalizePaymentService(element);
    initializeCouponFormSubmit(element);
  }
};
